import { INDRAApiService } from './api.indra.service';
import { URL_ROOT } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
var PassengerApisService = /** @class */ (function () {
    function PassengerApisService(apiService) {
        this.apiService = apiService;
    }
    PassengerApisService.prototype.savePassengerDocument = function (data, pnr, passenger_id) {
        var URL = URL_ROOT + "booking/pnrs/" + pnr + "/passengers/" + passenger_id + "/apis/update";
        return this.apiService.INDRA_put(URL, data);
    };
    PassengerApisService.ngInjectableDef = i0.defineInjectable({ factory: function PassengerApisService_Factory() { return new PassengerApisService(i0.inject(i1.INDRAApiService)); }, token: PassengerApisService, providedIn: "root" });
    return PassengerApisService;
}());
export { PassengerApisService };
